import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'footer_component',
  styleUrls: ['./footer.scss'],
  templateUrl: './footer.pug'
})

export class FooterComponent {
  public Logo = require('../../resources/images/logo.png');
}



// WEBPACK FOOTER //
// ./src/components/footer/footer.ts